// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__2YeX0","h1":"h1__3WvjJ","section":"section__3Ybw-"};